import ContainerHomGradientBorder from '~/components/Containers/ContainerHomGradientBorder'

interface Props {
  children: React.ReactNode
  innerClassName?: string
  noGradient?: boolean
}

export default function ProductCardContainer({
  children,
  innerClassName = '',
  noGradient = false,
}: Props): React.ReactElement {
  return (
    <ContainerHomGradientBorder
      gradientType={noGradient ? 'no-gradient' : 'logo'}
      innerClassName={`p-4 ${innerClassName}`}
      outerClassName="my-3 w-full h-full"
    >
      {children}
    </ContainerHomGradientBorder>
  )
}
